import React from 'react';
import styled, { css } from 'styled-components';
import InputSearch from '../../../../components/InputSearch';
import Loading from '../../../../components/Loading';
const arrowLeftIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow_left.svg';
import { SpecialistList as Specialist } from '../../../../models/Specialist';
import { SpecialistList } from '../SpecialistList';
import { EmptyList } from '../EmptyList';
import { Specialty } from '../../../../models/Specialty';
import { SpecialtyList } from '../SpecialtyList';

const Results = styled.div`
  height: 100%;

  .loading-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const ResultsWrapper = styled.div<{ standardSpacing?: boolean }>`
  ${({ standardSpacing }) => css`
    position: relative;
    padding: ${standardSpacing ? '0 32px' : '20px 0 0'};
  `}
`;

export type SearchProps = {
  fetchSpecialists?: (value: string) => void;
  // handleSelectSpecialist: (specialist: Specialist) => void;
  handleClear?: () => void;
  // selectedSpecialist: Specialist | undefined;
  standardSpacing: boolean;
  loading: boolean;
  placeholder?: string;
  specialistList?: Specialist[];
  changeContext?: () => void;
  rounded: boolean;
  handleClickResult: ({
    type,
    item,
    inputText
  }: {
    type: 'SPECIALTY' | 'SPECIALIST';
    item: Specialist | Specialty;
    inputText: string;
  }) => void;
  specialtyList?: Specialty[];
  initialValue?: string;
  clarIcon?: boolean;
  handleClearIcon?: () => void;
  onChangeSearchTherm?: (text: string) => void;
};

const Search: React.FC<SearchProps> = ({
  standardSpacing,
  loading,
  handleClear,
  handleClickResult,
  changeContext,
  placeholder,
  rounded,
  fetchSpecialists,
  specialistList = [],
  specialtyList = [],
  initialValue,
  clarIcon = true,
  handleClearIcon,
  onChangeSearchTherm
}) => {
  const [filterInputSearch, setFilterInputSearch] = React.useState('');

  React.useEffect(() => {
    setFilterInputSearch(initialValue ?? '');
  }, [initialValue]);

  React.useEffect(() => {
    onChangeSearchTherm?.(filterInputSearch);
  }, [filterInputSearch]);

  return (
    <>
      <InputSearch
        fullWidth={standardSpacing}
        placeholder={placeholder ? placeholder : 'Pesquisar'}
        rounded={rounded}
        value={filterInputSearch}
        handleChangeValue={setFilterInputSearch}
        iconLeft={
          standardSpacing && (
            <div
              style={{ marginRight: '16px' }}
              onClick={() => {
                changeContext && changeContext();
                handleClear && handleClear();
              }}
            >
              <img src={arrowLeftIcon} />
            </div>
          )
        }
        autoFocus={standardSpacing}
        onFocus={() => {
          !standardSpacing && changeContext && changeContext();
        }}
        onChange={value => {
          fetchSpecialists && fetchSpecialists(value);
        }}
        clearIcon={clarIcon}
        handleClearIcon={handleClearIcon}
      />

      <ResultsWrapper className="results-wrapper" standardSpacing={standardSpacing}>
        <Results data-testid="service-list">
          {loading ? (
            <div className="loading-wrapper">
              <Loading loading />
            </div>
          ) : standardSpacing ? (
            <>
              <SpecialtyList
                list={specialtyList.sort((item1, item2) => item1.name.localeCompare(item2.name))}
                handleSelect={item => {
                  handleClickResult({ type: 'SPECIALTY', item, inputText: item.name });
                  setFilterInputSearch(item.name);
                }}
              />
              <SpecialistList
                specialists={specialistList}
                handleSelectResource={item =>
                  handleClickResult({ type: 'SPECIALIST', item, inputText: filterInputSearch })
                }
              />
              <EmptyList
                visible={!specialistList.length && !specialtyList.length}
                info="Busque por médicos ou especialidades"
              />
            </>
          ) : (
            <></>
          )}
        </Results>
      </ResultsWrapper>
    </>
  );
};

export default Search;
